export default phoneNumber => {
  const suffixIndex = phoneNumber.search(/[A-Za-z]/);

  if (suffixIndex === -1) return "";

  return phoneNumber.slice(suffixIndex);
};
